export default __webpack_public_path__ + "static/media/support.icon.e1c08a1d.svg";